export const KB_SECTIONS_PAGE_SIZE = 5;

export type KbPageNumber = number | "…";

/** Page numbers with ellipsis, matching UX prototype getG2PageNumbers. */
export const getKbPageNumbers = (
  current: number,
  total: number,
): readonly KbPageNumber[] => {
  if (total <= 7) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }
  const pages: KbPageNumber[] = [1];
  if (current > 3) {
    pages.push("…");
  }
  for (
    let page = Math.max(2, current - 1);
    page <= Math.min(total - 1, current + 1);
    page += 1
  ) {
    pages.push(page);
  }
  if (current < total - 2) {
    pages.push("…");
  }
  if (total > 1) {
    pages.push(total);
  }
  return pages.filter((page, index, arr) => page !== arr[index - 1]);
};
